import React, { FC, useEffect } from "react";
import { Route, RouteProps, useRouteMatch } from "react-router";
import { Nesting } from "./types";
import { useDispatch } from "react-redux";
import { addKnownPattern } from "../store/routes";

export const toNestRoute = (root?: string) => (path?: string | string[]) => {
  if (!path) return path;
  const withRoot = (p: string) => {
    return `${root ?? ""}${p}`;
  };
  if (path instanceof Array) {
    return path.map(withRoot);
  }
  return withRoot(path);
};
export type TrackingProps = {
  trackAsParameterizedRoute?: boolean;
};
//See switch, we need to pass through some of the props from switch, like nest.
//However, these need to be set separately from the public props.
type PrivateProps = {
  computedNest?: boolean;
};
const PRoute: FC<RouteProps & Nesting & TrackingProps & PrivateProps> = ({
  nest,
  computedNest,
  path,
  trackAsParameterizedRoute,
  ...props
}) => {
  const { path: rootPath } = useRouteMatch();
  const dispatch = useDispatch();
  const root = nest || computedNest ? rootPath : undefined;
  const withRoot = toNestRoute(root);
  const newPath = withRoot(path);
  useEffect(() => {
    if (newPath && trackAsParameterizedRoute) {
      dispatch(addKnownPattern(newPath));
    }
  }, [newPath, trackAsParameterizedRoute, dispatch]);
  return <Route path={newPath} {...props} />;
};
export default PRoute;
